var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 17.5C35 27.165 27.165 35 17.5 35C7.83502 35 0 27.165 0 17.5C0 7.83502 7.83502 0 17.5 0C27.165 0 35 7.83502 35 17.5ZM26.3163 10.8712C25.6756 10.2304 24.6368 10.2304 23.9961 10.8712C23.9807 10.8866 23.9661 10.903 23.9526 10.9202L16.3568 20.5991L11.7772 16.0196C11.1365 15.3788 10.0977 15.3788 9.45704 16.0196C8.81633 16.6603 8.81633 17.699 9.45704 18.3397L15.2461 24.1288C15.8868 24.7696 16.9256 24.7696 17.5663 24.1288C17.5806 24.1146 17.5941 24.0995 17.6067 24.0838L26.3396 13.1676C26.9569 12.5252 26.9492 11.504 26.3163 10.8712Z",
    fill: "#00864D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/green-check.5e8e8ca842fe8d45d30d50959d98a271.svg";
export { ForwardRef as ReactComponent };